import {
  isManualTradeSecurity,
  type ManualTradeProductFlags,
} from '@src/components/OMS/ManualTradeView/manualTradeSecurityEligibility';
import { ProductTypeEnum, type Security, type Trade } from '@talos/kyoko';

export interface TradeModifyEligibility {
  modifiable: boolean;
  reason?: string;
}

const UNSUPPORTED_PRODUCT_TYPE_MESSAGES: Partial<Record<ProductTypeEnum, string>> = {
  [ProductTypeEnum.Share]: 'Share trades cannot be modified from the Manual Trade form',
  [ProductTypeEnum.GovernmentBond]: 'Government bond trades cannot be modified from the Manual Trade form',
  [ProductTypeEnum.OTC]: 'OTC / Loan trades cannot be modified from the Manual Trade form',
};

const DEFAULT_UNSUPPORTED_MESSAGE = "This trade's product type is not supported in the Manual Trade form";

function getUnsupportedProductTypeMessage(security: Security): string {
  return UNSUPPORTED_PRODUCT_TYPE_MESSAGES[security.ProductType] ?? DEFAULT_UNSUPPORTED_MESSAGE;
}

/**
 * Shared eligibility check for desktop and mobile trade Modify actions.
 *
 * Modify opens the Manual Trade form, so this uses {@link isManualTradeSecurity}:
 * Share and GovernmentBond are allowed when their feature flags are on.
 * When the trade symbol cannot be resolved, preserve existing behavior and allow modification.
 */
export function getTradeModifyEligibility(
  trade: Trade,
  securitiesBySymbol: Map<string, Security>,
  flags: ManualTradeProductFlags
): TradeModifyEligibility {
  const security = securitiesBySymbol.get(trade.Symbol);
  if (security == null) {
    return { modifiable: true };
  }

  if (isManualTradeSecurity(security, flags)) {
    return { modifiable: true };
  }

  return {
    modifiable: false,
    reason: getUnsupportedProductTypeMessage(security),
  };
}
